import React from 'react';
import { Typography, Alert } from 'antd';
import { SkuMigrationRow } from '../types';
import MigrationRow from '../components/MigrationRow';
import { CONVERSION_LABELS } from '../constants';
import { ConversionType } from '../types';

const { Title, Text } = Typography;

interface Props {
  conversionType:  ConversionType;
  migrationRows:   SkuMigrationRow[];
  rowErrors:       Record<number, string>;
  updateTargetName: (sourceSkuId: number, name: string) => void;
}

const StepMapNames: React.FC<Props> = ({
  conversionType,
  migrationRows,
  rowErrors,
  updateTargetName,
}) => {
  const hasErrors = Object.keys(rowErrors).length > 0;

  return (
    <div>
      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        Conversion: <strong>{CONVERSION_LABELS[conversionType]}</strong> — enter a unique name for
        each new SKU.
      </Text>

      {hasErrors && (
        <Alert
          type="error"
          message="Please fix the highlighted names before continuing."
          showIcon
          style={{ marginBottom: 12 }}
        />
      )}

      <Title level={5} style={{ marginBottom: 8 }}>
        {migrationRows.length} SKU{migrationRows.length !== 1 ? 's' : ''} to migrate
      </Title>

      <div style={{ maxHeight: 480, overflowY: 'auto', paddingRight: 4 }}>
        {migrationRows.map((row) => (
          <MigrationRow
            key={row.sourceSkuId}
            row={row}
            error={rowErrors[row.sourceSkuId]}
            updateTargetName={updateTargetName}
          />
        ))}
      </div>
    </div>
  );
};

export default StepMapNames;
